import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody } from '@/shared/api/generated';

import type { QualtricsInfo } from '../model';

type QualtricsPath = '/v1/workspaces/{workspace_id}/qualtrics';
type CreateParams = PathParams<QualtricsPath, 'post'> &
  RequestBody<QualtricsPath, 'post'>;

/**
 * Qualtrics API Key 기반 credential 생성
 */
export const createQualtricsInfo = ({
  workspace_id,
  api_key,
  data_center_id,
}: CreateParams): Promise<QualtricsInfo> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/qualtrics`, {
      api_key,
      data_center_id,
    })
    .then((res) => res.data);
